@import 'src/styles/palette';
@import 'src/styles/deviceBreakpoints';

.fileUploadWrapper {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  align-items: center;
  border: 0.75rem dashed _palette(border-black-10);
  border-radius: 25px;
  padding: 3.5rem 0;
  background-color: _palette(bg-secondary);

  &:not(.isHovering):hover {
    background-color: _palette(bg-hovered);
  }

  &.isHovering {
    background-color: _palette(secondary);

    input + label {
      opacity: 0;
    }
  }

  @include target(tablet) {
    padding: 1.5rem 0;
  }

  @include target(mobile) {
    padding: 0;
  }

  input {
    opacity: 0;
    z-index: -1;
    position: absolute;
  }

  input + label {
    width: auto;
    max-width: 50%;
    text-align: center;
    margin: 1rem 1rem 0 1rem;
    cursor: auto;
    pointer-events: none;

    @include target(mobile) {
      margin: 0;
      max-width: 100%;
    }
  }

  input:focus + label {
    outline: auto;
    outline-offset: 1rem;
  }

  .iconOuterContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
    width: 100%;

    .iconInnerContainer {
      position: relative;

      .cloud {
        position: relative;
        z-index: 10;
      }

      .file {
        position: absolute;
        left: 4.3rem;
        bottom: -2.5rem;
        z-index: 11;
      }

      .file:not(.isHovering) {
        visibility: hidden;
      }
    }
  }

  .uploadedFile {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 2.5rem;

    .filename {
      display: inline-block;
      max-width: 100%;
      margin: 0 !important;
    }
  }
}

.uploadLink {
  cursor: pointer;
  pointer-events: auto;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
}
